import FrontSonda from "@gcloud-npm/utils.monitoring.front-sonda";
import { CHARACTERISTIC_VALUES, CHARACTERISTICS, CQ_ACTION_CODES, TEXT_TYPES_CODES } from "../../catalogConstants";
import { WEBSERVICE_ERRORS } from "../../errorManagement/errorCatalog";
import { areThereProductOfferingTypesIntoOfferArray, getProductOfferingTextByType } from "../../utils/general";
import { DEVICE_VALUES, PRODUCT_OFFERING_TYPES, PRODUCT_TYPES } from "../../utils/catalog";

export const getOfferingCharacteristics = ({
  components,
  colorId,
  storageId,
  mail,
  netflixMode,
  simTypeToAutoSelect,
  speedId,
  multiSim,
  ottProductsArray,
}) => {
  const actionsResolved = [];
  let tvMailAdded = null;
  let netflixConfigured = false;
  let speedUnavailable = false;
  let r2rInfo = {
    r2rName: null,
    color: null,
    storage: null,
    r2rType: null,
    poId: null,
    colorId: null,
    storageId: null,
    swap: false,
  };
  const newTypeOfMultisim = [...multiSim.typeOfSims];
  if (Array.isArray(components) && components.length > 0) {
    components.forEach((component) => {
      const { customerQuotePossibleActions, productOfferingTypes } = component;

      if (areThereProductOfferingTypesIntoOfferArray(productOfferingTypes, PRODUCT_OFFERING_TYPES.INCLUDED_R2R)) {
        r2rInfo.r2rType = DEVICE_VALUES.INCLUDED;
      } else if (areThereProductOfferingTypesIntoOfferArray(productOfferingTypes, PRODUCT_OFFERING_TYPES.ADDITIONAL_R2R)) {
        r2rInfo.r2rType = DEVICE_VALUES.ADDITIONAL;
      }

      if (areThereProductOfferingTypesIntoOfferArray(productOfferingTypes, PRODUCT_OFFERING_TYPES.SWAP)) {
        r2rInfo.swap = true;
      }

      if (colorId) {
        r2rInfo.colorId = colorId;
      }

      if (storageId) {
        r2rInfo.storageId = storageId;
      }

      if (
        (Array.isArray(customerQuotePossibleActions) &&
        customerQuotePossibleActions.length > 0)
        || (Array.isArray(customerQuotePossibleActions) &&
        customerQuotePossibleActions.length === 1 &&
        Array.isArray(customerQuotePossibleActions[0].offeringCharacteristics) &&
        customerQuotePossibleActions[0].offeringCharacteristics.length > 0 )
      ) {
        customerQuotePossibleActions.forEach((possibleAction) => {
          const { id, offeringCharacteristics, offeringTerms, productOffering } = possibleAction;

          r2rInfo.poId = productOffering.id;
          const posibleActionPoId = productOffering.id;
          r2rInfo.r2rName = getProductOfferingTextByType(productOffering, TEXT_TYPES_CODES.ORDINARY); 

          if (
            Array.isArray(offeringCharacteristics) &&
            offeringCharacteristics.length > 0
          ) {
            const offeringCharacteristicsResolved = [];
            offeringCharacteristics.forEach((offeringCharacteristic) => {
              switch (offeringCharacteristic.id) {
                case CHARACTERISTICS.COLOR: {
                  if (colorId) {
                    r2rInfo.color = offeringCharacteristic.options.find(obj => obj.id === colorId)?.value;
                    offeringCharacteristicsResolved.push({
                      id: offeringCharacteristic.id,
                      value: colorId,
                    });
                    break;
                  } else {
                    const frontSonda = new FrontSonda({
                      processName: "getOfferingCharacteristics",
                      filePath: "reducers/normalizers/apiNeeds",
                    });
                    frontSonda.severalMessage({
                      info: `Se ha recibido una característica para resolver no esperada: ${offeringCharacteristic.id}`,
                    });
                  }
                  break;
                }
                case CHARACTERISTICS.STORAGE: {
                  if (storageId) {
                    r2rInfo.storage = offeringCharacteristic.options.find(obj => obj.id === storageId)?.value;
                    offeringCharacteristicsResolved.push({
                      id: offeringCharacteristic.id,
                      value: storageId,
                    });
                  } else {
                    const frontSonda = new FrontSonda({
                      processName: "getOfferingCharacteristics",
                      filePath: "reducers/normalizers/apiNeeds",
                    });
                    frontSonda.severalMessage({
                      info: `Se ha recibido una característica para resolver no esperada: ${offeringCharacteristic.id}`,
                    });
                  }
                  break;
                }
                case CHARACTERISTICS.SIM_TYPE: {
                  if(simTypeToAutoSelect){
                    const optionFound = offeringCharacteristic.options.find(
                      (option) => option.id === simTypeToAutoSelect
                    );
                    if(optionFound){
                      offeringCharacteristicsResolved.push({
                        id: offeringCharacteristic.id,
                        value: optionFound.id,
                      });
                    }
                  } else if (newTypeOfMultisim?.length > 0) {
                    const optionFound = offeringCharacteristic.options.find(
                      (option) => option.id === newTypeOfMultisim[0]
                    );
                    if(optionFound){
                      newTypeOfMultisim.shift();
                      offeringCharacteristicsResolved.push({
                        id: offeringCharacteristic.id,
                        value: optionFound.id,
                      });
                    }
                  }
                  break;
                }
                case CHARACTERISTICS.MAIL_TV: {
                  if (!offeringCharacteristic.value) {
                    if (mail) {
                      offeringCharacteristicsResolved.push({
                        id: offeringCharacteristic.id,
                        value: mail,
                      });
                      tvMailAdded = mail;
                    } else {
                      const frontSonda = new FrontSonda({
                        processName: "getOfferingCharacteristics",
                        filePath: "reducers/normalizers/apiNeeds",
                      });
                      frontSonda.severalMessage({
                        info: `Se ha recibido una característica para resolver no esperada: ${offeringCharacteristic.id}`,
                      });
                    }
                  }
                  break;
                }
                case CHARACTERISTICS.NETFLIX: {
                  const ottToSelectCarac = ottProductsArray.find(ottProduct => ottProduct.productOffering === posibleActionPoId);
                  if (ottToSelectCarac) {
                    const optionFound = offeringCharacteristic.options.find(
                      (option) => option.id === ottToSelectCarac.mode
                    );

                    if (optionFound) {
                      offeringCharacteristicsResolved.push({
                        id: offeringCharacteristic.id,
                        value: ottToSelectCarac.mode,
                      });
                    } else {
                      const frontSonda = new FrontSonda({
                        processName: "getOfferingCharacteristics",
                        filePath: "reducers/normalizers/apiNeeds",
                      });
                      frontSonda.severalMessage({
                        info: `Se ha recibido una característica para resolver no esperada: ${offeringCharacteristic.id}`,
                      });
                    }
                  }
                  else if (netflixMode) {
                    const optionFound = offeringCharacteristic.options.find(
                      (option) => option.id === netflixMode
                    );

                    if (optionFound) {
                      offeringCharacteristicsResolved.push({
                        id: offeringCharacteristic.id,
                        value: netflixMode,
                      });
                      netflixConfigured = true;
                    } else {
                      const frontSonda = new FrontSonda({
                        processName: "getOfferingCharacteristics",
                        filePath: "reducers/normalizers/apiNeeds",
                      });
                      frontSonda.severalMessage({
                        info: `Se ha recibido una característica para resolver no esperada: ${offeringCharacteristic.id}`,
                      });
                    }
                  } else {
                    const frontSonda = new FrontSonda({
                      processName: "getOfferingCharacteristics",
                      filePath: "reducers/normalizers/apiNeeds",
                    });
                    frontSonda.severalMessage({
                      info: `No se ha recibido la modalidad de netflix a contratar: ${offeringCharacteristic.id}`,
                    });
                  }
                  break;
                }
                case CHARACTERISTICS.SPEED: {
                  if(speedId){
                    const optionFound = offeringCharacteristic.options.find(
                      (option) => option.id === speedId
                    );
                    if(optionFound){
                      offeringCharacteristicsResolved.push({
                        id: offeringCharacteristic.id,
                        value: optionFound.id,
                      });
                    } else {
                      speedUnavailable = true;
                    }
                  }
                  break;
                }
                default: {
                  const frontSonda = new FrontSonda({
                    processName: "getOfferingCharacteristics",
                    filePath: "reducers/normalizers/apiNeeds",
                  });
                  frontSonda.severalMessage({
                    info: `Se ha recibido una característica para resolver no esperada: ${offeringCharacteristic.id}`,
                  });
                  break;
                }
              }
            });
            if (
              offeringCharacteristicsResolved.length > 0 ||
              (Array.isArray(offeringTerms) && offeringTerms.length > 1)
            ) {
              actionsResolved.push({
                id,
                offeringCharacteristics: offeringCharacteristicsResolved,
                offeringTerms: [],
              });
            }
          }
        });
      }
    });
  }

  if (!r2rInfo.r2rType) {
    r2rInfo = null;
  }
  return { actionsResolved, tvMailAdded, netflixConfigured, speedUnavailable, r2rInfo };
};

export const hasCharacteristicsToResolve = (components) => {
  let hasCharToResolve = false;
  if (Array.isArray(components) && components.length > 0) {
    components.forEach((component) => {
      const { customerQuotePossibleActions } = component;
      if (
        Array.isArray(customerQuotePossibleActions) &&
        customerQuotePossibleActions.length === 1
      ) {
        const { offeringTerms } = customerQuotePossibleActions[0];
        if (Array.isArray(offeringTerms) && offeringTerms.length > 1) {
          offeringTerms.forEach((offeringTerm) => {
            const { price, duration } = offeringTerm;
            if (
              price &&
              price.recurringCharges &&
              duration &&
              duration.amount
            ) {
              hasCharToResolve = true;
            } else {
              const frontSonda = new FrontSonda({
                processName: "hasCharacteristicsToResolve",
                filePath: "sagas/normalizers/ascertain",
              });
              frontSonda.severalMessage({
                info: `Se ha recibido un Commitment (OfferingTerm) sin la información necesaria para resolverlo: ${JSON.stringify(
                  offeringTerm
                )}`,
              });
            }
          });
        }
      }
    });
  }
  return hasCharToResolve;
};

export const isAccountWithRiskError = (error) => {
  const { response } = error;
  if (
    response &&
    response.status === "KO" &&
    response.error &&
    response.error.codigoErrorNegocio &&
    response.error.codigoErrorNegocio === WEBSERVICE_ERRORS.ACCOUNT_WITH_RISK
  ) {
    return true;
  }
  return false;
};

export const isPpipAvailable = (components) => {
  if (components && Array.isArray(components)) {
    for (let i = 0; i < components.length; i += 1) {
      const cqCharacteristics = components[i].customerQuotePossibleActions;

      if (cqCharacteristics && Array.isArray(cqCharacteristics)) {
        for (let j = 0; j < cqCharacteristics.length; j += 1) {
          const characteristic = cqCharacteristics[j];

          if (
            characteristic.productOffering &&
            characteristic.productOffering.ppipAvailable
          ) {
            return characteristic;
          }
        }
      }
    }
  }
  return null;
};

export const normalizeSecondarySelectionArray = (secondarySelection) => {
  const newSecondarySelection = [];

  if (secondarySelection && Array.isArray(secondarySelection)) {
    secondarySelection.forEach((item) => {
      const existingSelectionGroupIndex = newSecondarySelection.findIndex(
        (selection) => selection.id === item.id
      );
      if (existingSelectionGroupIndex > -1) {
        newSecondarySelection[
          existingSelectionGroupIndex
        ].customerQuoteItems.push(...item.customerQuoteItems);
      } else if (item.id && item.customerQuoteItems) {
        newSecondarySelection.push({
          id: item.id,
          customerQuoteItems: [...item.customerQuoteItems],
        });
      }
    });

    return newSecondarySelection;
  }

  return null;
};

export const normalizePortabilityInfo = (selectElementsNeeds) => {
  const { secondarySelection, phoneNumber, iccNumber } = selectElementsNeeds;
  let portabilityInfo;
  if (phoneNumber) {
    portabilityInfo = { ...portabilityInfo, [phoneNumber]: iccNumber };
  }
  if (
    secondarySelection &&
    Array.isArray(secondarySelection) &&
    secondarySelection.length > 0
  ) {
    secondarySelection.forEach((item) => {
      if (
        item.customerQuoteItems &&
        Array.isArray(item.customerQuoteItems) &&
        item.customerQuoteItems.length === 1 &&
        item.customerQuoteItems[0].clientPhoneNumberToBeAppliedTo
      ) {
        const secondarySelectionPortability = item.customerQuoteItems[0];
        portabilityInfo = {
          ...portabilityInfo,
          [secondarySelectionPortability.clientPhoneNumberToBeAppliedTo]:
            secondarySelectionPortability.iccNumber,
        };
      }
    });
  }
  return portabilityInfo;
};

export const normalizeSelectElementsSummaryChoices = (selectElementsNeeds) => {
  let choices = {};
  if (selectElementsNeeds.productType && selectElementsNeeds.selectedByClient) {
    choices = {
      [selectElementsNeeds.productType]: [
        {
          actionId: selectElementsNeeds.actionId,
          phoneNumber: selectElementsNeeds.phoneNumber,
          description: selectElementsNeeds.description,
          productOfferingName: selectElementsNeeds.productOfferingName,
          iccNumber: selectElementsNeeds.iccNumber,
        },
      ],
    };
  }

  if (
    selectElementsNeeds.secondarySelection &&
    Array.isArray(selectElementsNeeds.secondarySelection) &&
    selectElementsNeeds.secondarySelection.length > 0
  ) {
    selectElementsNeeds.secondarySelection.forEach((selection) => {
      if (selection && Array.isArray(selection.customerQuoteItems)) {
        if (
          selection.customerQuoteItems &&
          Array.isArray(selection.customerQuoteItems) &&
          selection.customerQuoteItems.length > 0
        ) {
          selection.customerQuoteItems.forEach((item) => {
            if (item) {
              const newItem = {
                actionId: selection.actionId,
                phoneNumber: item.clientPhoneNumberToBeAppliedTo,
                description: selection.description,
                productOfferingName: selection.productOfferingName,
                iccNumber: item.iccNumber,
              };

              if (choices[selection.productType]) {
                choices = {
                  ...choices,
                  [selection.productType]: [
                    ...choices[selection.productType],
                    newItem,
                  ],
                };
              } else {
                choices = {
                  ...choices,
                  [selection.productType]: [newItem],
                };
              }
            }
          });
        } else if (selection.actionId === CQ_ACTION_CODES.NO_ACTION) {
          const newItem = {
            actionId: selection.actionId,
            description: selection.description,
            productOfferingName: selection.productOfferingName,
          };
          if (choices[selection.productType]) {
            choices = {
              ...choices,
              [selection.productType]: [
                ...choices[selection.productType],
                newItem,
              ],
            };
          } else {
            choices = {
              ...choices,
              [selection.productType]: [newItem],
            };
          }
        }
      }
    });
  }
  return choices;
};

export const normalizeSelectElementsChoices = (selectElementsNeeds) => {
  let choices = null;
  const mainChoice = {
    actionId: selectElementsNeeds.actionId,
    phoneNumber: selectElementsNeeds.phoneNumber,
    description: selectElementsNeeds.description,
    productOfferingName: selectElementsNeeds.productOfferingName,
    iccNumber: selectElementsNeeds.iccNumber,
  };
  if (
    selectElementsNeeds.secondarySelection &&
    Array.isArray(selectElementsNeeds.secondarySelection) &&
    selectElementsNeeds.secondarySelection.length > 0
  ) {
    selectElementsNeeds.secondarySelection.forEach((selection) => {
      if (selection && Array.isArray(selection.customerQuoteItems)) {
        if (
          selection.customerQuoteItems &&
          Array.isArray(selection.customerQuoteItems) &&
          selection.customerQuoteItems.length > 0
        ) {
          selection.customerQuoteItems.forEach((item) => {
            if (item) {
              const newItem = {
                actionId: selection.actionId,
                phoneNumber: item.clientPhoneNumberToBeAppliedTo,
                description: selection.description,
                productOfferingName: selection.productOfferingName,
                iccNumber: item.iccNumber,
              };

              if (mainChoice.secondaryChoices) {
                if (mainChoice.secondaryChoices[selection.productType]) {
                  mainChoice.secondaryChoices[selection.productType] = [
                    ...mainChoice.secondaryChoices[selection.productType],
                    newItem,
                  ];
                } else {
                  mainChoice.secondaryChoices[selection.productType] = [
                    newItem,
                  ];
                }
              } else {
                mainChoice.secondaryChoices = {
                  [selection.productType]: [newItem],
                };
              }
            }
          });
        } else if (selection.actionId === CQ_ACTION_CODES.NO_ACTION) {
          const newItem = {
            actionId: selection.actionId,
            description: selection.description,
            productOfferingName: selection.productOfferingName,
          };

          if (mainChoice.secondaryChoices) {
            if (mainChoice.secondaryChoices[selection.productType]) {
              mainChoice.secondaryChoices[selection.productType] = [
                ...mainChoice.secondaryChoices[selection.productType],
                newItem,
              ];
            } else {
              mainChoice.secondaryChoices[selection.productType] = [newItem];
            }
          } else {
            mainChoice.secondaryChoices = {
              [selection.productType]: [newItem],
            };
          }
        }
      }
    });
    choices = { [selectElementsNeeds.productType]: [mainChoice] };
  } else if(selectElementsNeeds.selectedByClient){
    choices = { [selectElementsNeeds.productType]: [mainChoice] };
  }
  return choices;
};
